import { Button } from 'components/Button';
import { StackedRadioCardGroup } from 'components/Forms';
import { Heading } from 'components/Typography';
import { insuranceTypeOptions } from 'domains/signup/data/options';
import { InsuranceType } from 'domains/signup/data/types';
import { InsuranceContext, withInsuranceMachineState } from 'domains/signup/insurance/data/insuranceEntryContext';
import { isUndefined, noop } from 'lodash';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  defaultValue?: string;
  onSubmit: (value: string) => void;
};

const EnterInsuranceType: React.FC<Props> = ({ defaultValue, onSubmit }) => {
  const { t } = useTranslation();

  const [value, setValue] = useState<string | undefined>(defaultValue);

  return (
    <>
      <Heading level="h2" className="mb-64 sm-d:mb-40">
        {t(`signup.direct.steps.enterInsuranceType.title`)}
      </Heading>

      <StackedRadioCardGroup
        label={t('screener.questions.singleSelectTitle')}
        className="gap-14"
        disabled={false}
        showSelectedDot
        options={insuranceTypeOptions}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e.target.value as InsuranceType)}
        name="insuranceType"
        clearValue={noop}
        setError={noop}
        setValue={noop}
        tFunc={t}
        tPrefixKey="dropdowns.screener.insuranceType"
      />

      <Button
        size="lg"
        className="mt-64 sm-d:mt-40 sm-d:w-full"
        onClick={() => {
          onSubmit(value as string);
        }}
        disabled={isUndefined(value)}
      >
        {t('signup.direct.steps.enterInsuranceType.submit')}
      </Button>
    </>
  );
};

const InsuranceWrapper = () => {
  const insuranceType = InsuranceContext.useSelector(({ context }) => context.insuranceType);
  const { send } = InsuranceContext.useActorRef();

  const onSubmit = useCallback(
    (value: string) => {
      send({
        type: 'submitInsuranceType',
        insuranceType: value as InsuranceType,
      });
    },
    [send],
  );

  return <EnterInsuranceType defaultValue={insuranceType} onSubmit={onSubmit} />;
};

export const InsuranceEnterInsuranceType = withInsuranceMachineState(InsuranceWrapper, 'enterInsuranceType');
